<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right"></div>
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="is-pulled-right"><input class="input" type="date" v-model="start_date" /></div>
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
        <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{ this.total_garments }} garments</button>
    </div>
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
        <tr>
          <th width="60">&nbsp;</th>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Design</th>
          <th>Fabric</th>
          <th>Qty</th>
          <th>CAD ID</th>
          <th>Cutting</th>
         
          <th>&nbsp;</th>
          
        </tr>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="10" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="10" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
           <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>{{ order.total_qty }}</td>
          <td>{{order.cad_id}}</td>
          <td>{{ getCuttingLocation(order.gerber_print_location_id) }}</td>
         

            <td>
              <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id!=2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>
              </td>
          
             
			</tr>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: '',
      accessToken: '',
      start_date: '',
      initialLoadComplete: false
     
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getCuttingOrders2026(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
            this.initialLoadComplete = true
          }).bind(this)
        );
      },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             digital_print_cutting: 1,
             makeup_location_id: order.makeup_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.digital_print_cutting = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Cutting Gerber.xlsx')

    },
    getCuttingLocation(locationId) {
      const id = Number(locationId);
      if (id === 1) {
        return 'Strabane';
      }
      if (id === 2) {
        return 'Giurgiu';
      }
      return '-';
    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.digital_print_cutting == 0) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations(1);
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    /*if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }*/

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = 1
    }

    if (localStorage.printing_start_date) {
      this.start_date = localStorage.printing_start_date;
    }
    else{
      this.start_date = ''
    }
      
  },
  watch: {
    'selected_location_id'() {
        if(this.initialLoadComplete == false)
        {
          return false;
        }
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      this.orders = []
      this.getOrders();
    },
    'start_date'() {
      localStorage.printing_start_date = this.start_date
      this.orders = []
      this.getOrders();
    }
  }
}


</script>

